<template>
  <div class="Account">
    <div class="NewBuild"><Button type="info" shape="circle" icon="md-add" @click="NewBuildHandleClick">新增</Button></div>
    <Card style="width:350px;margin:1rem;float:left" v-for="item of UserInfos" :key="item.UserID">
        <p slot="title">
            <Icon type="md-person" />
            {{item.UserName}}
        </p>
        <a href="#" slot="extra" @click.prevent="DrawerShow(item)">
            <Icon type="ios-create-outline" />
            编辑
        </a>
        <p>账号:{{item.UserID}}</p>
        <p>密码:{{item.Password}}</p>
        <p>角色:{{item.RoleName}}</p>
        <p>状态:{{item.State}}</p>
    </Card>
    <!-- 抽屉 -->
    <div v-if="isDrawer">
      <span></span>
    <Drawer title="账号信息维护" v-model="isDrawer" width="80" :mask-closable="false">
      <Form ref="formCustom" :model="UserInfo" :rules="ruleCustom">
        <Row :gutter="32">
          <Col span="12">
            <FormItem label="账号" label-position="top" prop="UserID">
              <Input v-model="UserInfo.UserID" placeholder="必填" value="UserInfo.UserID"/>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="用户名" label-position="top" prop="UserName">
              <Input  v-model="UserInfo.UserName" placeholder="必填" value="UserInfo.UserName"/>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="32">
          <Col span="12">
            <FormItem label="密码" label-position="top">
              <Input type="password" v-model="UserInfo.Password"  value="UserInfo.Password"/>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="账号状态" label-position="top" prop="State">
              <Select v-model="UserInfo.State" placeholder="必填" value="UserInfo.State">
                <Option value="正常">正常</Option>
                <Option value="锁定">锁定</Option>
                <Option value="停用">停用</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="32">
          <Col span="12">
            <FormItem label="角色" label-position="top">
              <Select v-model="UserInfo.RoleID" value="UserInfo.RoleName" :label-in-value="true" @on-change="RoleHandleClick" clearable filterable>
                <Option :value="item.RoleID" v-for="item of RoleList" :key="item.RoleID">{{item.RoleName}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
          </Col>
        </Row>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px" @click="CancelHandleClick">取消</Button>
        <Button type="primary" @click="SubmitHandleClick('formCustom')">提交</Button>
        <Poptip
        v-if="UserInfo.UserID !== 'admin' && isNewBuild !== 0"
        style="float:right"
        confirm
        title="你确定要删除这个账号信息吗?"
        @on-ok="DeleteHandleClick">
           <Button type="error">删除</Button>
        </Poptip>
      </div>
    </Drawer>
    <Spin size="large" fix v-if="spinShow"></Spin>
    </div>
  </div>
</template>

<script>
import { GetUserInfo, ChangeAccountInfo, GetRoleInfo } from '../../../api/Account'

export default {
  name: 'Account',
  data () {
    const validateUserID = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入用户账号'))
      }
      callback()
    }
    const validateUserName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入用户姓名'))
      } else {
        callback()
      }
    }
    const validateState = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请选择用户状态'))
      } else {
        callback()
      }
    }
    return {
      UserInfos: Array,
      UserInfo: {
        UserID: String,
        UserName: String,
        Password: String,
        State: String,
        RoleName: String,
        RoleID: String
      },
      isDrawer: false,
      spinShow: false,
      isNewBuild: 0,
      RoleList: [],
      ruleCustom: {
        UserID: [{ validator: validateUserID, trigger: 'blur' }],
        UserName: [{ validator: validateUserName, trigger: 'blur' }],
        State: [{ validator: validateState, trigger: 'blur' }]
      }
    }
  },
  mounted: function () {
    this.GetUserInfoApi()
    this.GetGetRoleInfoApi()
  },
  methods: {
    GetUserInfoApi () {
      this.spinShow = true
      GetUserInfo().then((res) => {
        if (res.IsSuccess) {
          this.UserInfos = res.Data
        }
        this.spinShow = false
      })
    },
    GetGetRoleInfoApi () {
      GetRoleInfo().then((res) => {
        if (res.IsSuccess) {
          this.RoleList = res.Data
        }
        this.spinShow = false
      })
    },
    // 弹出抽屉
    DrawerShow (item) {
      this.isNewBuild = 1
      this.UserInfo = item
      this.isDrawer = true
    },
    // 隐藏抽屉
    CancelHandleClick () {
      this.isDrawer = false
    },
    // 提交用户信息
    SubmitHandleClick (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          ChangeAccountInfo({
            UserID: this.UserInfo.UserID,
            UserName: this.UserInfo.UserName,
            Password: this.UserInfo.Password,
            State: this.UserInfo.State,
            RoleID: this.UserInfo.RoleID,
            operation: this.isNewBuild
          }).then((res) => {
            if (res.IsSuccess) {
              this.$Message['success']({
                background: true,
                content: '提交成功'
              })
              this.GetUserInfoApi()
              this.isDrawer = false
            } else {
              this.$Message.error(res.message)
            }
          })
        } else {
          this.$Message.error('Fail!')
        }
      })
    },
    // 点击新增按钮
    NewBuildHandleClick () {
      this.isNewBuild = 0
      this.UserInfo = {
        UserID: '',
        UserName: '',
        Password: '',
        State: '',
        RoleName: '',
        RoleID: ''
      }
      this.isDrawer = true
    },
    // 删除账号
    DeleteHandleClick () {
      this.isNewBuild = 2
      ChangeAccountInfo({
        UserID: this.UserInfo.UserID,
        UserName: this.UserInfo.UserName,
        Password: this.UserInfo.Password,
        State: this.UserInfo.State,
        RoleID: this.UserInfo.RoleID,
        operation: 2
      }).then((res) => {
        if (res.IsSuccess) {
          this.$Message['success']({
            background: true,
            content: '删除成功'
          })
          this.GetUserInfoApi()
          this.isDrawer = false
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    // 角色选择回调
    RoleHandleClick (value) {
      this.UserInfo.RoleID = value.value
      this.UserInfo.RoleName = value.label
    }
  }
}
</script>
<style scoped>
.Account{
  overflow: hidden;
}
.NewBuild{
  margin-left: 1rem;
  width: 100%;
  height: 2rem;
}
</style>>
